// Slovenian UI copy (the only locale, spec decision #14).
// vue-i18n syntax note: "{x}" is interpolation, "|" separates plural forms and "@" starts a
// linked message — write a literal at-sign as {'@'}.
export default {
    general: {
        more_info: 'Več informacij',
        add:            'Dodaj',
        edit:           'Uredi',
        delete:         'Izbriši',
        remove:         'Odstrani',
        cancel:         'Prekliči',
        save:           'Shrani',
        close:          'Zapri',
        back:           'Nazaj',
        refresh:        'Osveži',
        sign_out:       'Odjava',
        loading:        'Nalagam …',
        optional:       'neobvezno',
        yes:            'da',
        no:             'ne',
        configured:     'nastavljeno',
        not_configured: 'ni nastavljeno',
    },
    brand: {
        product_name: 'Imprion Avtomati',
        tagline:      'Prijava avtomatov FURS',
    },
    nav: {
        machines:        'Avtomati',
        imports:         'Množični uvoz',
        audit:           'Revizijska sled',
        settings:        'Nastavitve',
        security:        'Varnost',
        admin:           'Administracija',
        admin_users:     'Uporabniki',
        admin_companies: 'Podjetja',
        admin_settings:  'Nastavitve sistema',
        admin_audit:     'Sistemska revizija',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    footer: {
        rpe_attribution: 'Vir: GURS, Register naslovov (CC BY 4.0)',
    },
    env: {
        test:         'TEST',
        production:   'PRODUKCIJA',
        test_badge:   'TEST',
        test_tooltip: 'Testno okolje FURS — prijave niso prave, nalepke niso za tisk.',
    },
    admin_mode: {
        bar: 'Skrbniški način: {company}. Vaša dejanja se beležijo kot dejanja skrbnika.',
    },
    roles: {
        owner:        'Lastnik',
        member:       'Član',
        admin:        'Skrbnik',
        system_admin: 'Sistemski skrbnik',
        user:         'Uporabnik',
    },
    status: {
        active:  'Aktiven',
        blocked: 'Blokiran',
    },
    plural: {
        machines: '{n} avtomat | {n} avtomata | {n} avtomati | {n} avtomatov',
    },
    errors: {
        generic_error: 'Prišlo je do napake. Poskusite znova.',
        invalid_data:  'Podatki niso veljavni.',
        not_found:     'Ni najdeno.',
        unauthorized:  'Niste prijavljeni.',
        forbidden:     'Za to dejanje nimate pravic.',
        rate_limited:  'Preveč poskusov. Poskusite pozneje.',
        on_add:        'Dodajanje ni uspelo.',
        on_edit:       'Shranjevanje ni uspelo.',
    },
    success: {
        add:  'Dodano.',
        edit: 'Shranjeno.',
    },
    validation: {
        required: 'To polje je obvezno.',
        email:    'Vnesite veljaven e-poštni naslov.',
        max:      'Največ {n} znakov.',
    },
    help: {
        ioa:    'Oznaka poslovnega prostora pri FURS, na avtomatu nalepka »IOA: oznaka«. Predlagano oznako dodeli sistem; oblike predpona + števke ni mogoče vnesti ročno.',
        type_f: 'Samo vrsta F: brez električnega napajanja, zunaj vaših poslovnih prostorov, brez navzočnosti osebe. Prodaje se ne sporoča.',
    },
    table: {
        empty:       'Ni podatkov.',
        per_page:    'Vrstic na stran',
        total:       'Skupaj: {n}',
        select_page: 'Izberi vse na strani',
        select_all:  'Izberi vse, ki ustrezajo filtru',
        select_row:  'Izberi vrstico',
    },
    confirm: {
        title:      'Potrditev',
        ok:         'Potrdi',
        type_label: 'Za potrditev vpišite »{text}«',
    },
    json: {
        copy:     'Kopiraj',
        download:     'Prenesi JSON',
        download_raw: 'Prenesi',
        copied:   'Kopirano v odložišče.',
    },
    map: {
        label:       'Zemljevid lokacije avtomata',
        no_location: 'Lokacija še ni določena.',
        pin:         'Lokacija avtomata',
    },
    notifications: {
        title:    'Obvestila',
        empty:    'Ni obvestil.',
        mark_all: 'Označi vse kot prebrano',
        unread:   'neprebrano',
    },
    company_switcher: {
        label:       'Izberi podjetje',
        none:        'Ni izbranega podjetja',
        create:      'Ustvari novo podjetje',
        invitations: 'Povabila ({n})',
        admin_mode:  'skrbniški način',
        open_failed: 'Podjetja ni bilo mogoče odpreti.',
    },

    // ---- Sign-in ---------------------------------------------------------------------------
    login: {
        title:               'Prijava ali registracija',
        subtitle:            'Vnesite e-poštni naslov. Poslali vam bomo kodo za prijavo — gesla niso potrebna.',
        email:               'E-pošta',
        continue:            'Nadaljuj',
        or:                  'ali',
        passkey:             'Prijava s ključem za dostop',
        passkey_unsupported: 'Ta brskalnik ne podpira ključev za dostop.',
        passkey_failed:      'Prijava s ključem za dostop ni uspela.',
        code_title:          'Vnesite kodo',
        code_sent:           'Vnesite kodo, ki smo jo poslali na {email}.',
        code:                'Šestmestna koda',
        code_hint:           'Koda in povezava v sporočilu veljata 15 minut. Povezava vas prijavi neposredno v brskalniku, kjer jo odprete.',
        sign_in:             'Prijava',
        wrong_code:          'Koda ni pravilna ali je potekla.',
        change_email:        'Spremeni e-pošto',
        resend:              'Pošlji novo kodo',
        resend_in:           'Novo kodo lahko zahtevate čez {s} s',
        terms_note:          'Z uporabo portala se strinjate s',
        terms_link:          'pogoji uporabe',
        link_signing_in:     'Prijavljam …',
        link_failed:         'Prijava s povezavo ni uspela',
        link_invalid:        'Povezava ni veljavna ali je potekla. Zahtevajte novo kodo.',
        back_to_login:       'Na prijavo',
    },
    welcome: {
        title:          'Dobrodošli v portalu Imprion Avtomati',
        subtitle:       'Še dva podatka in lahko začnete.',
        full_name:      'Ime in priimek',
        terms_agree:    'Strinjam se s pogoji uporabe',
        terms_read:     'preberi',
        terms_required: 'Za uporabo portala se morate strinjati s pogoji uporabe.',
        continue:       'Nadaljuj',
    },
    terms: {
        title:    'Pogoji uporabe portala Imprion Avtomati',
        version:  'Različica {v}',
        changed:  'Pogoji uporabe so se spremenili. Za nadaljevanje jih preberite in potrdite.',
        agree:    'Strinjam se',
        s1_title: 'Ponudnik.',
        s1:       'Portal Imprion Avtomati upravlja IT TEAM d.o.o., Tržaška cesta 65, 2000 Maribor, matična številka 2195003, davčna številka 33519439 (v nadaljevanju: ponudnik).',
        s2_title: 'Predmet storitve.',
        s2:       'Portal omogoča evidentiranje prodajnih avtomatov, sporočanje podatkov o avtomatih Finančni upravi RS (FURS) z digitalnim potrdilom uporabnika in pripravo nalepk z identifikacijsko oznako avtomata (IOA).',
        s3_title: 'Uporabniški račun.',
        s3:       'Uporabnik se registrira z e-poštnim naslovom. Odgovoren je za varnost svojega e-poštnega predala in ključev za dostop ter za vsa dejanja, opravljena z njegovim računom.',
        s4_title: 'Odgovornost uporabnika.',
        s4:       'Uporabnik je sam odgovoren za:',
        s4_1:     'točnost in popolnost vnesenih podatkov,',
        s4_2:     'izpolnjevanje pogojev za avtomate vrste F (4. odstavek 14.a člena ZDavPR),',
        s4_3:     'pravočasno prijavo, spremembe in zaprtje avtomatov,',
        s4_4:     'označitev avtomatov z IOA,',
        s4_5:     'enoličnost oznak glede na druge poslovne prostore, ki jih prijavlja izven portala,',
        s4_6:     'izpolnjevanje vseh drugih obveznosti po ZDavPR in drugih predpisih.',
        s5_title: 'Digitalna potrdila.',
        s5:       'Uporabnik s prenosom digitalnega potrdila pooblašča ponudnika, da potrdilo uporablja izključno za sporočila FURS, ki jih sproži uporabnik ali član njegovega podjetja. Ponudnik potrdilo hrani šifrirano in ga ne posreduje tretjim osebam.',
        s6_title: 'Umetna inteligenca.',
        s6:       'Datoteke za množični uvoz se za razbiranje podatkov posredujejo zunanjemu ponudniku storitev umetne inteligence kot obdelovalcu. Rezultati so lahko napačni ali nepopolni; uporabnik jih mora pred potrditvijo preveriti.',
        s7_title: 'Storitev »kot je«.',
        s7:       'Storitev se zagotavlja takšna, kot je, in kot je na voljo, brez kakršnih koli izrecnih ali posrednih jamstev, vključno z jamstvom za neprekinjeno delovanje, brezhibnost ali primernost za določen namen. Ponudnik ne odgovarja za delovanje sistemov FURS.',
        s8_title: 'Omejitev odgovornosti.',
        s8:       'Skupna odgovornost ponudnika za kakršno koli škodo v zvezi z uporabo portala je omejena na znesek, ki ga je uporabnik plačal ponudniku za uporabo portala v zadnjih 12 mesecih pred nastankom škodnega dogodka. Dokler je uporaba brezplačna, znaša ta znesek 0 EUR. Ponudnik ne odgovarja za posredno škodo, izgubljeni dobiček, globe ali davke. Omejitev ne velja za škodo, povzročeno namenoma ali iz hude malomarnosti, kjer odgovornosti po zakonu ni mogoče omejiti.',
        s9_title: 'Varstvo osebnih podatkov.',
        s9:       'Ponudnik obdeluje osebne podatke skladno s Splošno uredbo o varstvu podatkov (GDPR) in politiko zasebnosti. Podatki o prijavah avtomatov in revizijska sled se hranijo 10 let.',
        s10_title: 'Prenehanje.',
        s10:       'Uporabnik lahko uporabo kadar koli preneha. Ponudnik lahko račun onemogoči ob kršitvi teh pogojev ali zlorabi storitve.',
        s11_title: 'Spremembe pogojev.',
        s11:       'Ponudnik lahko pogoje spremeni. O spremembah obvesti uporabnike, ki jih ob naslednji prijavi ponovno potrdijo.',
        s12_title: 'Pravo in pristojnost.',
        s12:       'Za te pogoje velja pravo Republike Slovenije. Za spore je pristojno stvarno pristojno sodišče v Mariboru.',
    },
    invitation: {
        title:           'Povabilo v podjetje',
        text:            'Povabljeni ste v podjetje {company} z vlogo »{role}«.',
        for_email:       'Povabilo je namenjeno naslovu {email}.',
        accept:          'Pridruži se',
        sign_in_first:   'Za pridružitev se najprej prijavite ali registrirajte s tem e-poštnim naslovom.',
        sign_in:         'Prijava',
        invalid:         'Povabilo ni veljavno.',
        status_pending:  'Povabilo čaka.',
        status_accepted: 'Povabilo je že sprejeto.',
        status_revoked:  'Povabilo je bilo preklicano. Prosite lastnika podjetja za novo.',
        status_expired:  'Povabilo je poteklo. Prosite lastnika podjetja za novo.',
    },
    company_setup: {
        invitations:   'Povabila',
        invited_by:    'povabil(a) {name}',
        join:          'Pridruži se',
        joined:        'Pridružili ste se podjetju.',
        create:        'Ustvari novo podjetje',
        create_hint:   'Vnesite podatke zavezanca, ki je lastnik avtomatov. Postali boste lastnik podjetja v portalu.',
        create_submit: 'Ustvari podjetje',
        created:       'Podjetje je ustvarjeno.',
        skip:          'Preskoči',
        skipped:       'Dokler ne pripadate podjetju, je na voljo le ta zaslon. Podjetje lahko ustvarite kadar koli ali počakate na povabilo.',
    },
    company: {
        legal_name:          'Naziv podjetja',
        tax_number:          'Davčna številka',
        tax_number_short:    'DŠ',
        tax_valid:           'Davčna številka je veljavna.',
        tax_invalid:         'Davčna številka ni veljavna (kontrolna števka).',
        tax_format:          'Davčna številka ima 8 števk.',
        address_search:      'Poišči naslov v registru',
        vat_id:              'ID za DDV',
        vat_format:          'Oblika: SI in 8 števk.',
        registration_number: 'Matična številka',
        reg_format:          'Matična številka ima 7 ali 10 števk.',
        contact_phone:       'Telefon',
        contact_email:       'E-pošta za stik',
    },
    address: {
        search_placeholder: 'Npr. Dunajska 24 Lj',
        search_label:       'Iskanje naslova v registru prostorskih enot',
        type_more:          'Vpišite vsaj 3 znake.',
        no_results:         'Ni zadetkov v registru naslovov.',
        street:             'Ulica',
        house_number:       'Hišna številka',
        house_number_short: 'Št.',
        addition:           'Dodatek',
        postal_code:        'Poštna št.',
        postal_code_format: 'Poštna številka ima 4 števke.',
        post_office:        'Pošta',
        city:               'Kraj (pošta)',
        community:          'Naselje',
    },

    // ---- Machines ----------------------------------------------------------------------------
    passkey_banner: {
        title: 'Naslednjič se prijavite hitreje — dodajte ključ za dostop.',
        add:   'Dodaj ključ za dostop',
    },
    onboarding: {
        title:           'Prvi koraki',
        subtitle:        'Trije koraki do prve prijave avtomata pri FURS.',
        company:         'Vnesite podatke podjetja',
        company_cta:     'Podatki podjetja',
        certificate:     'Naložite potrdilo FURS',
        certificate_cta: 'Naloži potrdilo',
        machine:         'Dodajte prvi avtomat',
        machine_cta:     'Dodaj avtomat',
        done:            'opravljeno',
        todo:            'še ni opravljeno',
    },
    banners: {
        cert_expiring:    'Vaše potrdilo FURS poteče {date}. Naložite novo.',
        upload_new:       'Naloži novo',
        open_certificate: 'Potrdilo',
        failed:           'Sporočanje ni uspelo za {count}.',
        show_them:        'Prikaži jih',
        job_running:      '{kind} poteka: {done} od {total}.',
        show_progress:    'Prikaži napredek',
    },
    counters: {
        total:          'Skupaj',
        added:          'Nepotrjeni',
        confirmed:      'Potrjeni',
        decommissioned: 'Odjavljeni',
        failed_dot:     '{n} neuspešno',
    },
    machines: {
        add:           'Dodaj avtomat',
        import_file:   'Uvozi iz datoteke',
        export:        'Izvozi ({n})',
        exported:      'Izvoženih avtomatov: {n}.',
        export_failed: 'Izvoz ni uspel.',
        empty_title:   'Še nimate avtomatov',
        empty_text:    'Dodajte prvi avtomat ročno ali uvozite seznam iz datoteke.',
        search:        'Iskanje po IOA, oznaki ali naslovu',
        status_filter: 'Filter stanja',
        no_match:      'Noben avtomat ne ustreza iskanju.',
        row_actions:   'Dejanja za {ioa}',
        filter: {
            all:            'Vsi',
            active:         'Vsi razen odjavljenih',
            added:          'Nepotrjeni',
            failed:         'Neuspešno sporočeni',
            confirmed:      'Potrjeni',
            decommissioned: 'Odjavljeni',
        },
    },
    bulk: {
        region:         'Množična dejanja',
        selected:       'Izbranih: {n}',
        clear:          'Počisti izbor',
        confirm:        'Potrdi ({n})',
        stickers:       'Prenesi nalepke ({n})',
        delete:         'Izbriši ({n})',
        decommission:   'Odjavi ({n})',
        note_mixed:     'Nalepke in odjava veljajo za {confirmed} potrjenih, potrditev in brisanje pa za {added} nepotrjenih.',
        note_stickers:  'Nalepke samo za {confirmed} potrjenih; {skipped} nepotrjenih je izpuščenih.',
        note_confirm:   'Potrditev samo za {added} nepotrjenih; {skipped} drugih je izpuščenih.',
        delete_confirm: 'Izbrišem {count}? Avtomati še niso bili sporočeni FURS, zato jih lahko izbrišete brez sledi pri FURS.',
        deleted:        'Izbrisanih: {n}.',
        export:         'Izvozi ({n})',
    },
    machine: {
        ioa:               'IOA',
        internal_label:    'Interna oznaka',
        location:          'Lokacija',
        location_mode:     'Način lokacije',
        status_label:      'Stanje',
        last_reported:     'Zadnje sporočanje',
        latitude:          'Zemljepisna širina',
        longitude:         'Zemljepisna dolžina',
        coordinates:       'Koordinate',
        furs_note:         'Opomba za FURS',
        internal_note:     'Interna opomba',
        register:          'Register naslovov',
        source:            'Vir',
        source_manual:     'ročni vnos',
        source_import:     'množični uvoz',
        attestation:       'Izjava za vrsto F',
        failed:            'Neuspešno',
        being_reported:    'Sporoča se …',
        confirm:           'Potrdi',
        retry:             'Poskusi znova',
        download_sticker:  'Prenesi nalepko',
        decommission:      'Odjavi',
        history:           'Zgodovina',
        upload_cert_first: 'Najprej naložite potrdilo FURS.',
        delete_confirm:    'Izbrišem osnutek avtomata {ioa}? FURS za ta avtomat še ne ve.',
        deleted:           'Avtomat {ioa} je izbrisan.',
        replace_offer:     'Novi avtomat {new} je potrjen. Želite zdaj odjaviti stari avtomat {old}?',
        status: {
            added:          'Nepotrjen',
            confirmed:      'Potrjen',
            decommissioned: 'Odjavljen',
        },
        mode: {
            address: 'Naslov',
            geo:     'GPS koordinate',
        },
        timeline: {
            created:        'Dodan',
            confirmed:      'Potrjen pri FURS',
            reported:       'Sprememba sporočena FURS',
            decommissioned: 'Odjavljen pri FURS',
        },
        drawer: {
            data:           'Podatki',
            timeline:       'Časovnica',
            submissions:    'Sporočila FURS',
            no_submissions: 'Avtomat še ni bil sporočen FURS.',
            open_entry:     'Vpis v sledi',
            history:        'Druge spremembe',
            in_register:    'iz registra',
        },
        dialog: {
            title_add:           'Dodaj avtomat',
            title_edit:          'Uredi avtomat {ioa}',
            type_f:              'Vrsta F — mehanski avtomat brez električnega napajanja, zunaj vaših prostorov, brez navzočnosti osebja.',
            ioa_help:            'Pustite predlagano oznako ali vnesite svojo. Samo črke in števke, brez presledkov.',
            ioa_chars:           'Samo črke in števke, brez presledkov.',
            ioa_free:            '{ioa} je prosta.',
            ioa_generated:       '{ioa} — naslednja oznaka podjetja.',
            ioa_previously:      'Uporabljena prej, odjavljena {date}.',
            ioa_locked:          'Oznake potrjenega avtomata ni mogoče spremeniti.',
            replace:             'Druga oznaka? Zamenjaj z novim avtomatom',
            internal_label_help: 'Vaša številka ali ime, ne pošlje se FURS.',
            location_help:       'Prednost ima naslov (tudi najbližji). GPS uporabite le, če naslova ni. Naslov iz registra brez ulice se FURS pošlje s koordinatami.',
            paste_coords_placeholder: '46.0569, 14.5057 ali povezava Google/Apple Maps',
            address_search:      'Poiščite naslov, npr. Dunajska 24 Lj',
            from_register:       'Iz registra naslovov',
            not_from_register:   'Ni iz registra',
            not_in_register:     'Naslova ni v registru naslovov. Preverite ga ali izberite naslov iz iskalnika.',
            paste_coords:        'Prilepite koordinate ali povezavo',
            paste_coords_help:   'Povezava Google ali Apple Maps ali npr. »46,05, 14,50«.',
            my_location:         'Uporabi mojo lokacijo',
            nearest:             'Poišči najbližji naslov',
            nearest_found:       'Najbližji naslov: {label} ({m} m).',
            nearest_none:        'V bližini ni naslova iz registra.',
            use_address:         'Uporabi naslov',
            drag_pin:            'Bucko lahko povlečete ali kliknete na zemljevid.',
            no_geolocation:      'Brskalnik ne podpira določanja lokacije.',
            geolocation_failed:  'Lokacije ni bilo mogoče določiti.',
            coord_range:         'Koordinata ni v veljavnem obsegu.',
            coord_decimals:      'Največ 6 decimalnih mest.',
            outside_si:          'Točka je zunaj Slovenije. Preverite koordinate.',
            more:                'Več',
            furs_note_help:      'Neobvezno, do 1000 znakov. Pošlje se FURS.',
            internal_note_help:  'Neobvezno. Ne pošlje se FURS.',
            keep_open:           'Ohrani okno odprto za naslednji avtomat',
            add:                 'Dodaj',
            add_confirm:         'Dodaj in potrdi',
            save_confirm:        'Shrani in potrdi',
            save_report:         'Shrani in sporoči FURS',
            report_note:         'Zakon zahteva, da se sprememba sporoči pred začetkom veljavnosti, zato potrjenega avtomata ni mogoče shraniti brez sporočila FURS. Interna oznaka in opomba se shranita brez sporočila.',
            added:               'Avtomat {ioa} je dodan.',
        },
    },
    furs: {
        confirm_title:        'Sporočilo FURS',
        report_title:         'Sporoči spremembo FURS',
        decommission_title:   'Odjava avtomata pri FURS',
        confirm_one:          'Sporočim 1 avtomat FURS ({env}): {ioa}, {location}, vrsta F, velja od {date}.',
        confirm_many:         'Sporočim {count} FURS ({env}), vrsta F, velja od {date}.',
        decommission_one:     'FURS bo {ioa} označil kot zaprt. Tega za ta avtomat ni mogoče razveljaviti.',
        decommission_many:    'FURS bo {count} označil kot zaprte. Tega ni mogoče razveljaviti.',
        show_list:            'Prikaži seznam ({n})',
        diff_field:           'Polje',
        diff_before:          'Prej',
        diff_after:           'Novo',
        attestation:          'Potrjujem, da so navedeni avtomati brez električnega napajanja, stojijo izven mojih poslovnih prostorov in delujejo brez navzočnosti fizične osebe (4. odstavek 14.a člena ZDavPR).',
        type_ioa:             'Za potrditev vpišite oznako {ioa}',
        type_count:           'Za potrditev vpišite število avtomatov ({n})',
        confirm_submit_one:   'Sporoči FURS',
        confirm_submit_many:  'Sporoči {n} FURS',
        report_submit:        'Sporoči FURS',
        decommission_submit:  'Odjavi pri FURS',
        test_env_note:        'Testno okolje: sporočila gredo na testni strežnik FURS.',
    },
    job: {
        kind: {
            confirm:      'Potrjevanje',
            report:       'Sporočanje spremembe',
            decommission: 'Odjava',
        },
        running_title:     '{kind} pri FURS',
        result_title:      '{kind} — rezultat',
        progress:          'Sporočenih {done} od {total}, neuspešnih {failed}.',
        background_note:   'Sporočanje teče v ozadju. Okno lahko zaprete — nadaljuje se tudi, če zaprete zavihek.',
        succeeded:         'Uspešno',
        failed:            'Neuspešno',
        failed_rows:       'Neuspešni avtomati',
        open_audit:        'Vpis v sledi',
        hide:              'Skrij',
        retry_failed:      'Poskusi znova neuspele',
        download_stickers: 'Prenesi nalepke za uspešne ({n})',
        done_ok:           'FURS je sprejel vse ({n}).',
        done_failed:       'Sporočanje ni uspelo za {n}.',
    },
    stickers: {
        title:          'Prenos nalepk',
        one:            'Prenesete nalepko za {ioa} (PDF, 60 × 25 mm).',
        many:           'Prenesete {n} nalepk v eni datoteki ZIP (en PDF na nalepko).',
        skipped_note:   'Nalepke samo za {n} potrjenih avtomatov; {skipped} nepotrjenih je izpuščenih.',
        advice:         'Naročite vremensko obstojno, UV-odporno vinilno nalepko z laminacijo. Zakon zahteva, da je oznaka zaščitena pred uničenjem.',
        format_note:    'Datoteka za tiskarno: PDF 1.4, 3 mm dodatka za porezavo, rezalne oznake, besedilo v krivuljah. Strani: motiv, rezalna linija, predogled.',
        download_one:   'Prenesi PDF',
        download_many:  'Prenesi ZIP ({n})',
        downloaded:     'Prenesenih nalepk: {n}.',
        failed:         'Nalepk ni bilo mogoče pripraviti.',
        preview_alt:    'Predogled nalepke',
        preview_failed: 'Predogleda ni bilo mogoče naložiti.',
    },

    // ---- Import --------------------------------------------------------------------------
    imports: {
        upload_title:          'Množični uvoz',
        upload_subtitle:       'Naložite katero koli datoteko s seznamom avtomatov. Podatke razbere umetna inteligenca, vi jih pregledate pred dodajanjem.',
        drop_label:            'Povlecite datoteke sem ali kliknite za izbiro',
        drop_description:      'Do 10 datotek, do 20 MB vsaka: CSV, XLSX, XLS, ODS, PDF, DOCX, DOC, ODT, RTF, TXT, XML, JSON, MD, JPG, PNG, HEIC, WEBP, EML, MSG.',
        template:              'Predloga:',
        template_free:         'Datoteke po predlogi se preberejo brez umetne inteligence in ne štejejo v omejitev.',
        start:                 'Začni uvoz ({n})',
        ai_note:               'Datoteke se za razbiranje posredujejo ponudniku umetne inteligence (OpenAI). Rezultate pred potrditvijo preverite.',
        quota_extra:           'Preostali dodatni uvozi: {n}',
        quota_left:            'Danes preostalih uvozov: {left} od {limit}',
        quota_reached:         'Dnevna omejitev je dosežena. Naslednji uvoz bo mogoč ob {time}.',
        quota_reached_no_time: 'Dnevna omejitev je dosežena.',
        too_many:              'Največ {n} datotek naenkrat.',
        too_big:               'Datoteka {name} je večja od 20 MB.',
        past:                  'Pretekli uvozi',
        none:                  'Še ni uvozov.',
        rows_added:            '{rows} najdenih, {added} dodanih',
        col: {
            created: 'Čas',
            files:   'Datoteke',
            status:  'Stanje',
            rows:    'Vrstice',
            user:    'Uporabnik',
        },
    },
    import: {
        title:                'Uvoz',
        back:                 'Vsi uvozi',
        extracting:           'Razbiram podatke … ({done} od {total} delov)',
        extracting_note:      'Uvoz teče v ozadju. Stran lahko zapustite in se vrnete pozneje — obvestili vas bomo, ko bo pregled pripravljen.',
        failed:               'Uvoz ni uspel.',
        cancelled:            'Uvoz je preklican.',
        done:                 'Uvoz je zaključen. Dodanih avtomatov: {n}.',
        go_machines:          'Na avtomate',
        show_furs_job:        'Rezultat sporočanja',
        ai_usage:             'Ponudnik {provider}, model {model}, žetoni: {input} vhodnih, {output} izhodnih.',
        saving:               'Shranjujem …',
        only_problems:        'Prikaži samo težave',
        show_source:          'Prikaži vir',
        hide_source:          'Skrij vir',
        regenerate:           'Ustvari nove IOA ({n})',
        regenerated:          'Nove oznake za {n} vrstic.',
        accept_suggestions:   'Sprejmi predlagane naslove',
        suggestions_accepted: 'Predlagani naslovi so sprejeti.',
        remove:               'Odstrani izbrane ({n})',
        remove_confirm:       'Odstranim {n} vrstic iz uvoza?',
        cancel:               'Prekliči uvoz',
        cancel_confirm:       'Prekličem uvoz? Avtomati, ki še niso dodani, ne bodo dodani.',
        add:                  'Dodaj {n} avtomatov',
        add_confirm:          'Dodaj in potrdi {n}',
        added:                'Dodanih avtomatov: {n}.',
        nothing_to_add:       'Ni izbranih vrstic brez napak.',
        generated:            'samodejno',
        row_check:            'Izberi vrstico {ref}',
        row_ok:               'V redu',
        row_added:            'Že dodano',
        search_address:       'Poišči naslov',
        pick_candidate:       'Izberite naslov',
        use_suggestion:       'Predlog: {label}',
        no_problem_rows:      'Ni vrstic s težavami.',
        source:               'Vir',
        hover_row:            'Premaknite miško nad vrstico.',
        no_rows:              'V datotekah ni bilo najdenih avtomatov.',
        no_rows_hint:         'Preverite datoteke ali uporabite predlogo.',
        step: {
            upload: 'Nalaganje',
            review: 'Pregled',
            done:   'Končano',
        },
        status: {
            uploaded:   'Naloženo',
            extracting: 'Razbiranje',
            ready:      'Za pregled',
            done:       'Končano',
            failed:     'Neuspešno',
            cancelled:  'Preklicano',
        },
        summary: {
            found:    '{n} najdenih avtomatov',
            ready:    '{n} pripravljenih',
            warnings: '{n} opozoril',
            errors:   '{n} napak',
        },
        rpe: {
            ok:        'V registru',
            multiple:  'Več možnosti',
            none:      'Ni v registru',
            suggested: 'Predlog',
            edited:    'Ročno urejeno',
        },
        col: {
            label:  'Oznaka',
            no:     'Št.',
            add:    'Dod.',
            postal: 'Pošt. št.',
            lat:    'Širina',
            lon:    'Dolžina',
            rpe:      'Register',
            source:   'Vir',
            problems: 'Težave',
            note:     'Interna opomba',
        },
        grid: {
            search:          'Iskanje po IOA, oznaki, naslovu',
            selected:        'Izbranih {n} od {total}',
            select_all:      'Izberi vseh {n} prikazanih',
            empty:           'Ni vrstic za ta filter.',
            export:          'Izvozi v predlogo',
            export_problems: 'Vrstice s težavami ({n})',
            export_pending:  'Vse nedodane ({n})',
            export_all:      'Vse vrstice ({n})',
            export_selected: 'Izbrane ({n})',
            export_none:     'Ni vrstic za izvoz.',
            exported:        'Izvoženih vrstic: {n}. Popravite jih in datoteko uvozite znova.',
            exported_all:    'Izvoženih vrstic: {n}.',
            export_failed:   'Izvoz ni uspel.',
            filter: {
                all:      'Vse ({n})',
                errors:   'Napake ({n})',
                warnings: 'Opozorila ({n})',
                ok:       'Pripravljene ({n})',
                added:    'Dodane ({n})',
            },
        },
    },

    // ---- Audit ---------------------------------------------------------------------------
    audit: {
        title:            'Revizijska sled',
        title_admin:      'Sistemska revizijska sled',
        subtitle:         'Vsa dejanja v izbranem podjetju, vključno s celotnimi zahtevami in odgovori FURS.',
        subtitle_admin:   'Vsa dejanja v vseh podjetjih.',
        empty:            'Ni vpisov za izbrane filtre.',
        system:           'sistem',
        admin_flag:       'Skrbnik',
        export_csv:       'Izvozi CSV',
        export_json:      'Izvozi JSON',
        export_failed:    'Izvoz ni uspel.',
        ip:               'IP naslov',
        user_agent:       'Brskalnik',
        correlation:      'ID povezave',
        jws_header:       'Glava JWS',
        jws_payload:      'Vsebina zahteve',
        raw_token:        'Surovi žeton (JWS)',
        decoded_payload:  'Dekodirana vsebina odgovora',
        raw_body:         'Surovi odgovor',
        signature_ok:     'podpis preverjen',
        signature_not_ok: 'podpis ni preverjen',
        no_request:       'Ta vpis nima zahteve FURS.',
        no_response:      'Ta vpis nima odgovora FURS.',
        tab: {
            summary:  'Povzetek',
            request:  'Zahteva',
            response: 'Odgovor',
        },
        col: {
            time:    'Čas',
            user:    'Uporabnik',
            company: 'Podjetje',
            action:  'Dejanje',
            area:    'Področje',
            target:  'Cilj',
            result:  'Rezultat',
            summary: 'Povzetek',
        },
        result: {
            success: 'uspešno',
            failure: 'neuspešno',
        },
        filter: {
            from:          'Od',
            to:            'Do',
            area:          'Področje',
            result:        'Rezultat',
            ioa:           'IOA',
            user:          'Uporabnik',
            company:       'Podjetje',
            all_companies: 'Vsa podjetja',
            search:        'Iskanje po povzetku in IOA',
            all:           'Vse',
            clear:         'Počisti filtre',
        },
        area: {
            auth:        'Prijava',
            machines:    'Avtomati',
            furs:        'Klici FURS',
            settings:    'Nastavitve',
            certificate: 'Potrdilo',
            import:      'Uvoz',
            stickers:    'Nalepke',
            admin:       'Administracija',
        },
        action: {
            auth__code_requested:            'Zahtevana koda',
            auth__code_verified:             'Koda potrjena',
            auth__code_failed:               'Napačna koda',
            auth__magic_link_used:           'Prijava s povezavo',
            auth__user_created:              'Ustvarjen račun',
            auth__passkey_added:             'Dodan ključ za dostop',
            auth__passkey_renamed:           'Preimenovan ključ za dostop',
            auth__passkey_removed:           'Odstranjen ključ za dostop',
            auth__passkey_used:              'Prijava s ključem za dostop',
            auth__session_revoked:           'Odjava seje',
            auth__signed_out:                'Odjava',
            auth__terms_accepted:            'Sprejeti pogoji uporabe',
            auth__profile_changed:           'Spremenjen profil',
            auth__rate_limited:              'Preveč zahtev',
            machines__created:               'Dodan avtomat',
            machines__edited:                'Urejen avtomat',
            machines__deleted:               'Izbrisan avtomat',
            machines__attestation:           'Izjava za vrsto F',
            machines__confirm_started:       'Začeto potrjevanje',
            machines__confirm_succeeded:     'Potrjen pri FURS',
            machines__confirm_failed:        'Potrditev ni uspela',
            machines__report_succeeded:      'Sprememba sporočena',
            machines__report_failed:         'Sporočanje spremembe ni uspelo',
            machines__decommission_succeeded: 'Odjavljen pri FURS',
            machines__decommission_failed:   'Odjava ni uspela',
            furs__register:                  'FURS: prijava prostora',
            furs__register_batch:            'FURS: paketna prijava',
            furs__echo:                      'FURS: preizkus povezave',
            settings__company_created:       'Ustvarjeno podjetje',
            settings__company_changed:       'Spremenjeni podatki podjetja',
            settings__numbering_changed:     'Spremenjeno številčenje',
            settings__member_invited:        'Poslano povabilo',
            settings__invitation_resent:     'Ponovno poslano povabilo',
            settings__invitation_revoked:    'Preklicano povabilo',
            settings__member_joined:         'Član se je pridružil',
            settings__member_left:           'Član je izstopil',
            settings__member_removed:        'Odstranjen član',
            settings__role_changed:          'Spremenjena vloga',
            certificate__uploaded:           'Naloženo potrdilo',
            certificate__replaced:           'Zamenjano potrdilo',
            certificate__rejected:           'Zavrnjeno potrdilo',
            certificate__expiry_warning:     'Opozorilo o poteku potrdila',
            import__job_created:             'Začet uvoz',
            import__ai_call:                 'Klic umetne inteligence',
            import__rows_added:              'Dodane vrstice uvoza',
            import__cancelled:               'Preklican uvoz',
            import__failed:                  'Uvoz ni uspel',
            stickers__exported:              'Izvožene nalepke',
            admin__mode_entered:             'Skrbniški način',
            admin__user_blocked:             'Blokiran uporabnik',
            admin__user_unblocked:           'Odblokiran uporabnik',
            admin__company_blocked:          'Blokirano podjetje',
            admin__company_unblocked:        'Odblokirano podjetje',
            admin__membership_added:         'Dodano članstvo',
            admin__membership_removed:       'Odstranjeno članstvo',
            admin__system_role_changed:      'Spremenjena sistemska vloga',
            admin__settings_changed:         'Spremenjene sistemske nastavitve',
            admin__quota_changed:            'Spremenjena omejitev uvozov',
            admin__rpe_refresh:              'Osvežitev registra naslovov',
        },
    },

    // ---- Settings ------------------------------------------------------------------------
    settings: {
        tab: {
            company:     'Podjetje',
            certificate: 'Potrdilo',
            environment: 'Okolje',
            members:     'Člani',
            stickers:    'Nalepke',
            numbering:   'Številčenje',
        },
        read_only_member:        'Podatke podjetja lahko spreminjajo samo lastniki.',
        owners_only:             'To lahko urejajo samo lastniki podjetja.',
        sticker_preview:         'Predogled nalepke',
        furs_env:                'Okolje FURS',
        env_tip:                 'Določa ga namestitev portala. Testna in produkcijska namestitev imata ločene podatke; testne nalepke nosijo napis »TEST — ne tiskati«.',
        sticker_size:            'Velikost',
        sticker_content:         'Vsebina',
        sticker_content_value:   'IOA, naziv in naslov podjetja',
        sticker_file:            'Datoteka',
        sticker_file_value:      'PDF 1.4, CMYK, 3 mm za porezavo, rezalne oznake, besedilo v krivuljah',
        sticker_preview_hint:    'Nalepka uporablja naziv in naslov podjetja.',
        env_readonly:            'Okolje določa namestitev portala in ga ni mogoče spremeniti.',
        env_test_text:           'Ta namestitev uporablja testni strežnik FURS (blagajne-test.fu.gov.si). Prijave niso prave, nalepke nosijo napis »TEST — ne tiskati«. Potrebujete testno potrdilo FURS.',
        env_prod_text:           'Ta namestitev uporablja produkcijski strežnik FURS (blagajne.fu.gov.si). Prijave so pravno veljavne.',
        software_supplier:       'Dobavitelj programske opreme',
        stickers_text:           'Velikost, postavitev in vsebina nalepke so določene. Na nalepki so oznaka »IOA: …«, naziv in naslov podjetja.',
        stickers_fact_size:      'Velikost 60 × 25 mm, 3 mm dodatka za porezavo, zaobljeni robovi.',
        stickers_fact_content:   'Vsebina po 7.c členu pravilnika: »IOA: oznaka«, naziv in naslov podjetja.',
        stickers_fact_print:     'PDF 1.4 v CMYK z rezalnimi oznakami in besedilom v krivuljah — pripravljen za tiskarno.',
        stickers_fact_confirmed: 'Nalepke je mogoče prenesti samo za potrjene avtomate.',
    },
    cert: {
        current:        'Potrdilo FURS',
        valid:          'veljavno',
        expired:        'poteklo',
        subject:        'Imetnik',
        tax_number:     'Davčna številka',
        environment:    'Okolje',
        valid_until:    'Velja do',
        issuer:         'Izdajatelj',
        serial:         'Serijska številka',
        uploaded:       'Naloženo',
        echo_ok:        'Povezava s FURS deluje.',
        echo_ok_ms:     'Povezava s FURS deluje ({ms} ms).',
        echo_failed:    'Povezava s FURS ne deluje.',
        connection:     'Povezava FURS',
        test:           'Preizkusi povezavo',
        replace:        'Zamenjaj',
        none:           'Potrdilo še ni naloženo. Dokler ga ne naložite, avtomatov ni mogoče sporočiti FURS.',
        upload_title:   'Naloži potrdilo',
        replace_title:  'Zamenjaj potrdilo',
        file:           'Datoteka potrdila (.p12 ali .pfx)',
        file_drop:      'Povlecite datoteko sem ali kliknite za izbiro',
        password:       'Geslo potrdila',
        upload:         'Naloži',
        uploaded_ok:    'Potrdilo je naloženo in povezava preizkušena.',
        storage_note:   'Zasebni ključ hranimo šifriran (AES-256-GCM). Datoteke in gesla ne shranimo, potrdila ni mogoče prenesti nazaj.',
        howto_title:    'Kako pridobim potrdilo?',
        howto_1:        'Prijavite se v eDavke kot zavezanec ali pooblaščenec.',
        howto_2:        'Izberite Davčne blagajne → Digitalna potrdila za davčne blagajne.',
        howto_3:        'Zahtevajte novo potrdilo in prenesite datoteko .p12 z geslom.',
        howto_4:        'Datoteko in geslo naložite tukaj. Davčna številka potrdila mora biti enaka davčni številki podjetja.',
        howto_test:     'Testna namestitev potrebuje testno potrdilo (izdajatelj »Tax CA Test«).',
        howto_prod:     'Produkcijska namestitev potrebuje produkcijsko potrdilo (izdajatelj »TaxCA«).',
    },
    members: {
        title:            'Člani',
        invite:           'Povabi člana',
        name:             'Ime',
        email:            'E-pošta',
        role:             'Vloga',
        role_help:        'Član ne more urejati podatkov podjetja, potrdila in članov.',
        role_of:          'Vloga za {name}',
        joined:           'Pridružen',
        remove_of:        'Odstrani {name}',
        remove_confirm:   'Odstranim {name} iz podjetja?',
        removed:          'Član je odstranjen.',
        role_changed:     'Vloga je spremenjena.',
        invitations:      'Povabila',
        no_invitations:   'Ni odprtih povabil.',
        expires:          'poteče {date}',
        resend:           'Pošlji znova',
        resent:           'Povabilo je ponovno poslano.',
        revoke:           'Prekliči',
        revoke_confirm:   'Prekličem povabilo za {email}?',
        revoked:          'Povabilo je preklicano.',
        send_invite:      'Pošlji povabilo',
        invited:          'Povabilo je poslano na {email}.',
        inv_status: {
            pending:  'čaka',
            accepted: 'sprejeto',
            revoked:  'preklicano',
            expired:  'poteklo',
        },
    },
    numbering: {
        text:           'Avtomati brez lastne oznake dobijo samodejno oznako: predpona in zaporedna številka podjetja (npr. IMA00001). Števec se samo povečuje in se nikoli ne ponovi.',
        locked:         'Predpona in število števk sta zaklenjeni, ker je bila prva oznaka že dodeljena.',
        prefix:         'Predpona',
        prefix_help:    'Oznake oblike predpona + števke dodeljuje samo sistem. Po prvi dodeljeni oznaki se predpona in število števk zaklenejo.',
        prefix_invalid: 'Predpona ima 1 do 10 črk ali števk.',
        padding:        'Število števk',
        too_long:       'Predpona in števke skupaj imajo lahko največ 20 znakov.',
        example:        'Primer',
        next:           'Naslednja oznaka',
        reserved:       'Oznake oblike {prefix} + same števke dodeljuje samo sistem; ročno jih ni mogoče vnesti.',
    },
    security: {
        profile:                     'Profil',
        passkeys:                    'Ključi za dostop',
        passkeys_subtitle:           'Prijava brez e-pošte s prstnim odtisom, obrazom ali PIN-om naprave.',
        add_passkey:                 'Dodaj ključ za dostop',
        create_passkey:              'Ustvari ključ',
        passkey_name:                'Ime ključa',
        passkey_name_placeholder:    'npr. MacBook, iPhone',
        passkey_name_help:           'Npr. »MacBook« ali »iPhone«.',
        no_passkeys:                 'Nimate ključev za dostop.',
        created:                     'dodan {date}',
        last_used:                   'zadnja uporaba {date}',
        never_used:                  'še ni uporabljen',
        rename:                      'Preimenuj',
        remove_passkey_confirm:      'Odstranim ključ »{name}«? Prijava z e-pošto bo še vedno delovala.',
        passkey_added:               'Ključ za dostop je dodan.',
        passkey_removed:             'Ključ za dostop je odstranjen.',
        passkey_exists:              'Ta naprava že ima ključ za vaš račun.',
        passkey_failed:              'Ključa za dostop ni bilo mogoče ustvariti.',
        email_fallback:              'Prijava z e-pošto vedno deluje, tudi brez ključev.',
        sessions:                    'Aktivne seje',
        sign_out_everywhere:         'Odjava povsod',
        sign_out_everywhere_confirm: 'Odjavim vse seje, tudi to?',
        sign_out_session:            'Odjavi',
        unknown_device:              'Neznana naprava',
        this_device:                 'ta naprava',
        signed_in:                   'prijava {date}',
        companies:                   'Moja podjetja',
        no_companies:                'Ne pripadate nobenemu podjetju.',
        leave:                       'Zapusti',
        leave_confirm:               'Zapustim podjetje {company}?',
        left:                        'Zapustili ste podjetje {company}.',
    },

    // ---- Administration ------------------------------------------------------------------
    admin: {
        status:      'Stanje',
        company:     'Podjetje',
        actions_for: 'Dejanja za {name}',
        users: {
            title:                'Uporabniki',
            subtitle:             'Uporabnikov ni mogoče izbrisati, le blokirati.',
            search:               'Iskanje po e-pošti ali imenu',
            user:                 'Uporabnik',
            companies:            'Podjetja',
            system_role:          'Sistemska vloga',
            activity:             'Dejavnost',
            created:              'ustvarjen {date}',
            last_login:           'zadnja prijava {date}',
            block:                'Blokiraj',
            unblock:              'Odblokiraj',
            block_confirm:        'Blokiram {email}? Vse seje se takoj končajo, nova prijava ne bo mogoča.',
            blocked:              'Uporabnik je blokiran.',
            unblocked:            'Uporabnik je odblokiran.',
            make_admin:           'Naredi sistemskega skrbnika',
            revoke_admin:         'Odvzemi vlogo skrbnika',
            make_admin_confirm:   '{email} postane sistemski skrbnik z dostopom do vseh podjetij?',
            revoke_admin_confirm: '{email} izgubi vlogo sistemskega skrbnika?',
            role_changed:         'Sistemska vloga je spremenjena.',
            add_to_company:       'Dodaj v podjetje',
            added:                'Uporabnik je dodan v podjetje.',
            remove_from:          'Odstrani iz {company}',
            remove_confirm:       'Odstranim {email} iz podjetja {company}?',
            removed:              'Uporabnik je odstranjen iz podjetja.',
        },
        companies: {
            title:               'Podjetja',
            subtitle:            'Podjetij ni mogoče izbrisati, le blokirati.',
            search:              'Iskanje po nazivu ali davčni številki',
            created:             'ustvarjeno {date}',
            people:              'Lastniki in člani',
            members_count:       'članov: {n}',
            machines:            'Nepotrj. / potrj. / odjav.',
            certificate:         'Potrdilo do',
            no_cert:             'ni potrdila',
            imports:             'Uvozi',
            quota_line:          'danes {used} od {limit}',
            extra_line:          'dodatnih {n}',
            open:                'Odpri',
            quota:               'Omejitev uvozov',
            quota_title:         'Omejitev uvozov',
            quota_used:          'Danes porabljenih: {used} od {limit}',
            extra_left:          'Preostali dodatni uvozi: {n}',
            daily_override:      'Dnevna omejitev podjetja (datotek / 24 h)',
            used_today:          'Porabljeno (24 h)',
            extra_left_label:    'Dodatni uvozi',
            daily_override_help: 'Datoteke z UI v 24 urah. Velja, če ni izbrana privzeta omejitev.',
            use_default:         'Uporabi privzeto omejitev sistema',
            add_extra:           'Dodaj dodatne uvoze',
            add_extra_help:      'Dodatni uvozi se porabijo najprej in ne upoštevajo dnevne omejitve.',
            quota_saved:         'Omejitev je shranjena.',
            block:               'Blokiraj',
            unblock:             'Odblokiraj',
            block_confirm:       'Blokiram {company}? Člani ga ne bodo mogli odpreti in klici FURS ne bodo mogoči. Podatki ostanejo.',
            blocked:             'Podjetje je blokirano.',
            unblocked:           'Podjetje je odblokirano.',
        },
        settings: {
            title:               'Nastavitve sistema',
            ai_model:            'Model umetne inteligence (OpenAI)',
            ai_model_help:       'Model OpenAI s strukturiranim izhodom ter vhodom PDF in slik.',
            default_limit:       'Privzeta omejitev uvozov (datotek / 24 h)',
            default_limit_help:  'Število datotek z UI na podjetje v 24 urah, če podjetje nima svoje omejitve.',
            email_from_name:     'Ime pošiljatelja',
            email_from_address:  'E-pošta pošiljatelja',
            email_reply_to:      'Naslov za odgovor',
            status:              'Stanje sistema',
            furs_env:            'Okolje FURS',
            openai:              'OpenAI',
            email:               'Pošiljanje e-pošte',
            rpe:                 'Register naslovov',
            rpe_counts:          '{a} naslovov, {p} poštnih številk',
            rpe_loaded:          'naloženo {date}',
            rpe_attempt:         'zadnji poskus {date}',
            rpe_refresh:         'Osveži zdaj',
            rpe_loading:         'Nalagam register …',
            rpe_started:         'Osveževanje registra se je začelo.',
        },
    },
}
